// src/routes/UserRoutes.js
import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// Pages
import HomePage from "../components/User/Home/HomePage";
import LearningPage from "../components/User/Learning/LearningPage";

//import LaunchPadPage from "../components/User/Launchpad/LaunchPadPage";
//import GrowthLabPage from "../components/User/GrowthLab/GrowthLabPage";
//import StudioPage from "../components/User/Studio/StudioPage";


// Legal Pages
import TermsOfService from "../components/User/TermsOfService";
import PrivacyPolicy from "../components/User/PrivacyPolicy";
import RefundPolicy from "../components/User/RefundPolicy";


// Tools
//import ToolsIndex from "../components/User/Tools/ToolsIndex";
//import CompanyFormationDiagnostic from "../components/User/Tools/CompanyFormationDiagnosticTool/CompanyFormationDiagnostic";
//import BusinessPlanReadiness from "../components/User/Tools/BusinessPlanReadiness/BusinessPlanReadiness";
//import CapTableSimulator from "../components/User/Tools/CapTableTool/CapTableSimulator";

// Insights
//import InsightList from "../components/User/Insights/InsightList";
//import InsightPage from "../components/User/Insights/InsightPage";

/*
  🧭 ScrollToHashElement
  - Handles smooth scrolling for in page anchors (/#start-a-conversation)
  - Applies sticky header offset safely
*/
function ScrollToHashElement() {
    const { hash } = useLocation();

    useEffect(() => {
        if (!hash) return;

        const id = hash.replace("#", "");
        let retries = 0;
        const maxRetries = 25;

        if (!document.getElementById("scroll-offset-style")) {
            const style = document.createElement("style");
            style.id = "scroll-offset-style";
            style.innerHTML = `
                .scroll-offset {
                    scroll-margin-top: var(--header-height, 80px);

                }
            `;
            document.head.appendChild(style);
        }

        const tryScroll = () => {
            const el = document.getElementById(id);
            if (!el) {
                if (retries++ < maxRetries) {
                    setTimeout(tryScroll, 100);
                }
                return;
            }

            const header =
                document.querySelector("header") ||
                document.getElementById("site-header");

            const headerHeight = header
                ? Math.round(header.getBoundingClientRect().height)
                : 0;

            document.documentElement.style.setProperty(
                "--header-height",
                `${headerHeight}px`
            );

            el.classList.add("scroll-offset");
            el.scrollIntoView({ behavior: "smooth", block: "start" });
        };

        setTimeout(tryScroll, 60);
    }, [hash]);

    return null;
}

/*
  🧭 ScrollToTopOnRoute
  - Resets scroll position on ALL route changes
  - Skips when a hash is present (handled above)
*/
function ScrollToTopOnRoute() {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) return;
        window.scrollTo({ top: 0, behavior: "auto" });
    }, [location.pathname]);

    return null;
}

export default function UserRoutes() {
    return (
        <>
            <ScrollToHashElement />
            <ScrollToTopOnRoute />

            <Routes>
                {/* Home */}
                <Route path="/" element={<HomePage />} />

                {/* <Route path="/learning" element={<LearningPage />} /> */}


                {/* Static */}
                <Route path="/terms-and-conditions" element={<TermsOfService />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/refund-policy" element={<RefundPolicy />} />

                {/* Pillars 
                <Route path="/launchpad" element={<LaunchPadPage />} />
                <Route path="/growth" element={<GrowthLabPage />} />
                <Route path="/studio" element={<StudioPage />} />
                */}

                {/* Tools 
                <Route path="/tools" element={<ToolsIndex />} />
                <Route
                    path="/tools/company-formation-diagnostic"
                    element={<CompanyFormationDiagnostic />}
                />
                <Route
                    path="/tools/business-plan-readiness"
                    element={<BusinessPlanReadiness />}
                />
                */}

                {/* Insights 
                <Route path="/insights" element={<InsightList />} />
                <Route path="/insights/:slug" element={<InsightPage />} />
                */}

                {/* Fallback */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </>
    );
}
